module.exports = __webpack_public_path__ + "img/site_example.4b3315f3.png";